/* Blowhammer home 2026, list of the real garments (B-HOME 12/10/2026). Mouse or keyboard: the real photo of the line appears in
   the box beside the list. Touch: the first tap opens the line and shows the photo, the second tap
   follows the link. Every photo is requested only when its line is shown.
   S1 17/10/2026: under 750 px the list is a strip of photos with name and price, and a tap goes straight to the garment. */
(function () {
  function carica(img, riga) {
    if (!img || img.getAttribute('data-caricata') === riga.dataset.src) return;
    img.setAttribute('srcset', riga.dataset.srcset);
    img.setAttribute('src', riga.dataset.src);
    img.setAttribute('alt', riga.dataset.alt);
    img.setAttribute('data-caricata', riga.dataset.src);
  }
  document.querySelectorAll('[data-na-archivio]').forEach(function (sezione) {
    var riquadro = sezione.querySelector('.na-arch__anteprima');
    var anteprima = riquadro && riquadro.querySelector('img');
    var righe = sezione.querySelectorAll('.na-arch__riga');
    var tocco = false;
    function mostra(riga) {
      righe.forEach(function (r) { r.classList.toggle('is-attiva', r === riga); });
      if (anteprima && getComputedStyle(riquadro).display !== 'none') {
        carica(anteprima, riga);
        riquadro.hidden = false;
      }
    }
    righe.forEach(function (riga) {
      riga.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') mostra(riga); });
      riga.addEventListener('focus', function () { if (!tocco) mostra(riga); });
      riga.addEventListener('pointerdown', function (e) { tocco = e.pointerType !== 'mouse'; });
      riga.addEventListener('click', function (e) {
        if (!tocco || riga.classList.contains('is-aperta') || window.matchMedia('(max-width: 749px)').matches) return;
        e.preventDefault();
        righe.forEach(function (r) { r.classList.remove('is-aperta'); r.setAttribute('aria-expanded', 'false'); });
        riga.classList.add('is-aperta');
        riga.setAttribute('aria-expanded', 'true');
        carica(riga.querySelector('.na-arch__mini img'), riga);
        mostra(riga);
      });
    });
  });
})();
